export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12094.73f5a9aa.jpg";